import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Design.module.scss';

const Design = () => {
    return (
        <>
            <div className={styles.mainContainer}>
                <h2 className={styles.innerHeading}>UI/UX & Web Design</h2>
                <p className={styles.description}>
                    Great design is more than aesthetics — it’s about experience. Our creative team crafts user-centered designs that are intuitive, functional, and visually compelling. Whether it's an app interface or a website layout, we ensure every interaction counts.
                </p>
                <div className={styles.linksGrid}>
                    <Link to="/portfolio" state={{ filter: "Web" }} className={styles.link}>UI/UX Design</Link>
                    <Link to="/portfolio" state={{ filter: "Web" }} className={styles.link}>Website Redesign</Link>
                    <Link to="/portfolio" state={{ filter: "Web" }} className={styles.link}>Mobile App UI</Link>
                </div>
            </div>
        </>
    );
};

export default Design;
